export const CURRENCIES = [
  {
    alias: 'gbp',
    symbol: '\u00A3',
    title: 'GBP',
  },
  {
    alias: 'eur',
    symbol: '\u20AC',
    title: 'EUR',
  },
  {
    alias: 'pln',
    symbol: 'z\u0142',
    title: 'PLN',
  },
  {
    alias: 'usd',
    symbol: '$',
    title: 'USD',
  },
] as const
